import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const tagsTabEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-assets-object-class-view-tags-tab" */ './ui'),
	),
	getPreloadProps: () => ({
		extraProps: {},
	}),
});
